import { LandingPageService } from './../../../../../core/services/landing-page.service';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TicketPurchasedConfirmDialog } from './ticket-purchased-confirm.component';
import { Component, OnInit, Inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { API as AWS_API, Auth } from 'aws-amplify';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppService } from 'src/app/core/services/app.service';
import { CONST_AWS_API, API } from 'src/app/core/constants';
import { StorageService } from 'src/app/core/services/storage.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { environment } from 'src/environments/environment';
import { CommanSubscribeService } from 'src/app/core/services/comman-subscribe.service';
import { GroupPreferenceService } from 'src/app/core/services/group-preference.service';
import { Subscription, of } from 'rxjs';
import { shareReplay } from 'rxjs/operators';

@Component({
  selector: 'app-consumer-verification-code',
  templateUrl: './consumer-verification-code.component.html',
  styleUrls: ['./consumer-verification-code.component.scss']
})
export class ConsumerVerificationCodeComponent implements OnInit {

  formdata: any = {};
  verificationForm: FormGroup;
  request_from: string = "";
  getEventData: any = {};
  returnUrl: any = "";
  channelUrl: any;
  skipRedirection: any;
  subEvents: any;
  user_subscription_info: any;
  skipIcRedirection: any;
  liveEventInfo: any;
  performerInfoSubscription!: Subscription;
  organizationId: any;

  constructor(private matDialogRef: MatDialogRef<ConsumerVerificationCodeComponent>, public router: Router,
    private toastr: ToastrService, private _formBuilder: FormBuilder, private ngxLoader: NgxUiLoaderService,
    private storageService: StorageService, private landingPageService: LandingPageService,
    private commanSubscribeService: CommanSubscribeService,
    private groupPreferenceService: GroupPreferenceService,
    private appService: AppService, @Inject(MAT_DIALOG_DATA) private _data: any,
    private activeRoute: ActivatedRoute, private dialog: MatDialog) {
    this.formdata = _data.formdata;
    if (this.formdata && this.formdata.email) {
      this.formdata.email = this.formdata.email.toLowerCase();
    }
    this.request_from = _data.request_from;
    this.returnUrl = this.activeRoute.snapshot.queryParams.returnUrl;
  }
  settingsData: any = {}
  ngOnInit() {
    this.settingsData = this.commanSubscribeService.icWebpageSettingsData;
    this.buildForm();
    this.channelUrl = this.storageService.getItem('channelName')
    if (!this.router.url.includes(this.channelUrl)) {
      this.settingsData = {}
    }
    const initialPerformerInfo = this.commanSubscribeService.perfomerInfoData;
    if (initialPerformerInfo?.data?.Data?.[0]?.organization_id) {
      this.organizationId = initialPerformerInfo.data.Data[0].organization_id;
    }
    this.performerInfoSubscription = this.commanSubscribeService.getPerfomerInfo().subscribe(response => {
      if (response?.data?.Data?.[0]?.organization_id) {
        this.organizationId = response.data.Data[0].organization_id;
      }
    });
    this.getEventData = this.storageService.getItem('eventInfo');
    this.skipIcRedirection = this.storageService.getItem('skipIcRedirection');
    this.skipRedirection = this.storageService.getItem('skipRedirection');
  }

  buildForm() {
    this.verificationForm = this._formBuilder.group({
      codeOTP: ['', Validators.required]
    });
  }


  verificationOTP() {
    if (this.verificationForm.valid) {
      this.ngxLoader.start();
      Auth.confirmSignUp(this.formdata.email, this.verificationForm.value.codeOTP, {
        forceAliasCreation: true
      }).then(data => {
        this.ngxLoader.stop();
        this.matDialogRef.close("");
        if (this.request_from == "login") {
          this.toastr.success("User verified successfully");
          this.router.navigateByUrl('');
        } else {
          this.consumerSignIn();
        }
      }).catch(err => {
        this.ngxLoader.stop();
        console.log(err)
        this.toastr.error(err.message);
      });
    }
  }


  consumerSignIn() {
    this.ngxLoader.start();
    Auth.signIn({
      username: this.formdata.email,
      password: this.formdata.password,
      validationData: null,
    }).then(user => {
      this.ngxLoader.stop();
      if (user && user.signInUserSession && user.signInUserSession.accessToken &&
        user.signInUserSession.accessToken.jwtToken) {
        let myInit = {
          headers: {},
          response: true,
          body: {
            email: this.formdata.email
          }
        }
        this.ngxLoader.start();
        AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.GET_USER, myInit).then(response => {
          this.ngxLoader.stop();
          let userInfo = response.data.user;
          userInfo.signedIn = true;
          // userInfo.access_token = user.signInUserSession.accessToken.jwtToken;
          userInfo.access_token = userInfo.session_token;
          // this.storageService.setItem("user_Info", userInfo);
          localStorage.isFanLoginUser = true;
          this.commanSubscribeService.sendUserInfo(userInfo, this.organizationId);
          if (this.skipRedirection == 'yes') {
            // Signing in from mid-checkout (e.g. account creation prompted while buying an
            // add-on ticket) - stay on the page the buyer was on instead of jumping to
            // watch/schedule content, UNLESS this account already holds a ticket for this
            // event, in which case confirm with the buyer before leaving the checkout page.
            this.confirmIfAlreadyPurchased(userInfo);
          } else if (this.getEventData) {
            this.redirectForEventData();
          } else if (this.returnUrl) {
            this.router.navigate([this.returnUrl]);
          } else {
            this.router.navigateByUrl(this.router.url);
          }
        }).catch(error => {
          this.ngxLoader.stop();
        });
      }
    }).catch(err => {
      this.ngxLoader.stop();
      console.log(err);
      if (err && err.message) {
        this.toastr.error(err.message);
      }
    });
  }

  redirectForEventData() {
    if (this.getEventData.isEvent == 'channels') {
      this.router.navigateByUrl(`/c/${this.getEventData.channel_name}/profile`)
    } else if (this.getEventData.isEvent == 'vod') {
      this.router.navigateByUrl(`/watch/${this.getEventData.id}`)
    } else if (this.getEventData.isEvent == 'live' || this.getEventData.isEvent == 'upcoming') {
      this.router.navigateByUrl(`/stream/${this.getEventData.id}`);
    }
  }

  // Checks whether the just-signed-in account already holds a ticket for the event the buyer
  // was checking out for, and if so lets them choose to stay on the checkout page (e.g. to
  // finish buying an add-on ticket) or leave for the existing watch/schedule flow.
  confirmIfAlreadyPurchased(userInfo) {
    if (!this.getEventData || !this.getEventData.id) {
      return;
    }
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        "Authorization": `Bearer ${userInfo.access_token}`
      },
      response: true,
      body: {
        "stream_id": this.getEventData.id,
        "userid": userInfo.id
      }
    }
    this.ngxLoader.start();
    AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.GET_LIVE_EVENT_BY_ID, data).then(response => {
      this.ngxLoader.stop();
      const existingTickets = response?.data?.Data?.user_subscription_info;
      if (response.data.statusCode === '200' && existingTickets && existingTickets.length > 0) {
        const dialogRef = this.dialog.open(TicketPurchasedConfirmDialog, {
          panelClass: 'app-signout-confirmation',
          disableClose: true,
          data: { settingsData: this.settingsData }
        });
        dialogRef.afterClosed().subscribe(result => {
          if (result == 'no') {
            this.commanSubscribeService.sendScreenStatus(false);
            this.router.navigateByUrl(`${this.commanSubscribeService.getBasePathFromUrl(this.router.url)}/event/schedule/${existingTickets[0].ticket_key}`);
          }
        });
      }
    }).catch(() => {
      this.ngxLoader.stop();
    });
  }

  // authorizeAWSTokenToOurServer() {
  // let data = {
  //   email: this.formdata.email,
  //   first_name: this.formdata.first_name,
  //   last_name: this.formdata.last_name,
  //   phone_number: this.formdata.phone_number,
  //   date_of_birth: this.formdata.date_of_birth,
  //   signature: this.formdata.signature
  // }
  // this.appService.postRequest(API.AUTHORIZE, data).subscribe(result => {
  //   if (result.status == 200) {
  //     let access_token = {
  //       access_token: result.access_token,
  //       email: this.formdata.email,
  //       first_name: this.formdata.first_name,
  //       last_name: this.formdata.last_name,
  //       phone_number: this.formdata.phone_number,
  //       date_of_birth: this.formdata.date_of_birth,
  //     }
  //     this.storageService.setItem("user_Info", access_token);
  //     this.router.navigateByUrl('/userhome');
  //   }
  // }, error => {
  //   this.toastr.error(error);
  //   console.log('error =', error);
  // });
  // }

  // signupForOurServer() {
  //   let data = {
  //     email: this.formdata.email,
  //     first_name: this.formdata.first_name,
  //     last_name: this.formdata.last_name,
  //     phone_number: this.formdata.phone_number,
  //     date_of_birth: this.formdata.date_of_birth,
  //     signature: this.formdata.signature
  //   }
  //   this.appService.postRequest(API.AWS_SIGNUP, data).subscribe(result => {
  //     if (result.status == 200) {
  //       this.router.navigateByUrl('/userhome');
  //     }
  //   }, error => {
  //     this.toastr.error(error);
  //     console.log('error =', error);
  //   });
  // }


  resendSignUp() {
    this.ngxLoader.start();
    Auth.resendSignUp(this.formdata.email).then(() => {
      this.ngxLoader.stop();
      this.toastr.success('code resent successfully');
      // console.log('code resent successfully');
    }).catch(e => {
      this.ngxLoader.stop();
      console.log(e);
    });
  }

  // OL_verificationOTP() {
  //   if (this.verificationForm.valid) {
  //     this.ngxLoader.start();
  //     this.appService.OL_PutRequest(`api/2/mfa/users/${this.formdata.user_id}/registrations/${this.formdata.registration_id}`, { "otp": this.verificationForm.value.codeOTP }).subscribe(result => {
  //       if (result.status == "accepted") {
  //         this.OL_updateProfile((callBack) => {
  //           this.ngxLoader.stop();
  //           if (callBack == "success") {
  //             this.toastr.success("User verified successfully");
  //             this.router.navigateByUrl('');
  //             this.matDialogRef.close("");
  //           } else {
  //             this.toastr.error("User not verified.");
  //           }
  //         });
  //       } else {
  //         this.toastr.error("User verification status is" + result.status);
  //         this.ngxLoader.stop();
  //       }
  //     }, error => {
  //       this.ngxLoader.stop();
  //     });
  //   }
  // }

  OL_verificationOTP() {
    if (this.verificationForm.valid) {
      let myInit = {
        headers: {},
        response: true,
        body: {
          email: this.formdata.email ? this.formdata.email.toLowerCase() : "",
          type: "email_verification",
          otp: this.verificationForm.value.codeOTP,
          organization_id: this.organizationId || 0
        }
      }
      this.ngxLoader.start();
      AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.VERIFY_OTP, myInit).then(response => {
        if (response.status == 200 && response.data.status == 0) {
          response.data.user.access_token = response.data.user.session_token;
          this.commanSubscribeService.sendUserInfo(response.data.user, this.organizationId);
          this.OL_updateProfile(response.data.user, (callBack) => {
            this.ngxLoader.stop();
            if (callBack == "success") {
              this.toastr.success("User verified successfully");
              // this.router.navigateByUrl('');
              this.matDialogRef.close("");
              let userInfo = response.data.user;
              userInfo.signedIn = true;
              userInfo.access_token = userInfo.session_token;
              userInfo.is_profile_completed = true;
              let isAffiliateUser = userInfo.referral_code ? true : false;
              this.storageService.setItem("isAffiliateUser", isAffiliateUser);
              this.storageService.setItem("user_Info", { access_token: userInfo.access_token });
              this.storageService.setItem("affiliateReferralCode", userInfo?.referral_code);
              this.commanSubscribeService.sendUserInfo(userInfo, this.organizationId);
              localStorage.isFanLoginUser = true;
              this.storageService.deleteItem('eventInfo');
              this.storageService.deleteItem('isSubscribed');
              this.storageService.deleteItem('skipRedirection');
              this.storageService.deleteItem('skipIcRedirection');

              const userId = userInfo?.user_first_name + ' ' + userInfo?.user_last_name;
              (window as any).umami?.track(`Sign-UP Successfully by - ${userId}`)
              const payload = {
                actionType: "sign-up",
                metaData: {
                  title: `Sign-Up Successfully`,
                  timeStamp: new Date().toISOString()
                },
                organizationId: this.commanSubscribeService?.slugInfo?.organization_id || null,
              }
              this.commanSubscribeService.sendTriggeredEvent(payload);

              // Signup only: if this happened via a group-specific URL, seed the fan's preferred
              // group (reuses the AI-agent hero panel's save mechanism) so future no-group logins
              // can redirect straight to it. Saved once via shareReplay so it always fires exactly
              // one request regardless of which branch below subscribes to it - the group-redirect
              // branch further down waits for this to complete before opening the AI-agent panel,
              // so it fetches fresh (not pre-save) preference data instead of needing a reload.
              const signupGroupSlug = this.request_from === 'signup' && this.commanSubscribeService.activeGroupId
                ? this.commanSubscribeService.activeGroupSlug
                : '';
              const groupSeed$ = signupGroupSlug
                ? this.groupPreferenceService
                    .seedPreferredGroupOnSignup(
                      {
                        id: this.commanSubscribeService.activeGroupId,
                        name: this.commanSubscribeService.activeGroup?.group_name || this.commanSubscribeService.activeGroup?.name || '',
                        group_type: this.commanSubscribeService.activeGroup?.group_type || '',
                      },
                      userInfo.id,
                      this.organizationId,
                      this.channelUrl
                    )
                    .pipe(shareReplay(1))
                : of(void 0);
              groupSeed$.subscribe();

              console.log("skipRedirection", this.skipRedirection);
              if (this.skipRedirection == 'yes') {
                // Close this dialog first so the confirmation prompt (opened inside
                // confirmIfAlreadyPurchased, once its ticket check resolves) isn't stacked on
                // top of it.
                this.matDialogRef.close("success");
                this.confirmIfAlreadyPurchased(userInfo);
              } else {
                if (this.returnUrl && this.returnUrl.includes('/subscription-list')) {
                  let returnUrls = this.returnUrl.split("?returnUrl=");
                  if (returnUrls.length == 2) {
                    this.router.navigate([this.returnUrl]);
                    this.router.navigate([returnUrls[0]], { queryParams: { returnUrl: returnUrls[1] } });
                  } else {
                    this.router.navigate([this.returnUrl]);
                  }
                  this.matDialogRef.close("");
                  return;
                }
                if (this.getEventData && Object.keys(this.getEventData).length > 0) {
                  if (this.getEventData.isEvent == 'channels') {
                    this.router.navigateByUrl(`/c/${this.getEventData.channel_name}/profile`)
                  } else if (this.getEventData.isEvent == 'live' || this.getEventData.isEvent == 'upcoming' || this.getEventData.isEvent == 'vod') {
                    let ids;
                    ids = {
                      "stream_id": this.getEventData.id,
                      "userid": userInfo.id,
                    }
                    let data = {
                      headers: {
                        "Content-Type": "application/json",
                        "x-api-key": environment.AWS_Cognito.X_Api_Key,
                        "Authorization": `Bearer ${userInfo.access_token}`
                      },
                      response: true,
                      body: ids
                    }
                    this.ngxLoader.start();
                    AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.GET_LIVE_EVENT_BY_ID, data).then(response => {
                      this.ngxLoader.stop();
                      if (response.data.statusCode === '200') {
                        this.liveEventInfo = response['data']['Data'];
                        this.subEvents = this.liveEventInfo['subEvents'];
                        this.user_subscription_info = this.liveEventInfo['user_subscription_info'];
                        if ((this.getEventData.isEvent == 'vod' || this.liveEventInfo.stream_status == 'completed') && this.getEventData.slug != null && this.liveEventInfo.user_subscription_info && this.liveEventInfo.user_subscription_info.length == 0 && this.getEventData.allow_vod) {
                          if (this.getEventData.ref_code != '')
                            this.router.navigate([this.getEventData.channel_name +'/event/' + this.getEventData.slug + '/place-order'], { queryParams: { ref: this.getEventData.ref_code } });
                          else
                            this.router.navigateByUrl(`${this.getEventData.channel_name}/event/${this.getEventData.slug}/place-order`);
                        } else if (this.getEventData.allow_vod && this.liveEventInfo.user_subscription_info && this.liveEventInfo.user_subscription_info.length > 0) {
                          this.router.navigateByUrl(`watch/${this.getEventData.id}`);
                        } else if (!this.getEventData.allow_vod) {
                          this.toastr.error('Video recording is not available');
                        }
                        if ((this.getEventData.isEvent == 'upcoming' || this.getEventData.isEvent == 'live') && this.liveEventInfo && this.liveEventInfo.stream_status != 'completed') {
                          if (this.liveEventInfo && this.liveEventInfo.user_subscription_info && this.liveEventInfo.user_subscription_info.length == 0) {
                            if (!this.getEventData.message) {
                              if (this.getEventData.ref_code != '')
                                this.router.navigate([this.getEventData.channel_name + '/event/' + this.getEventData.slug + '/place-order'], { queryParams: { ref: this.getEventData.ref_code } });
                              else
                                this.router.navigateByUrl(`${this.getEventData.channel_name}/event/${this.getEventData.slug}/place-order`);
                            } else {
                              this.router.navigateByUrl(`${this.getEventData.channel_name}/event/${this.getEventData.slug}`);
                            }
                          } else {
                            this.commanSubscribeService.sendScreenStatus(false);
                            this.router.navigateByUrl(`${this.commanSubscribeService.getBasePathFromUrl(this.router.url)}/event/schedule/${this.user_subscription_info[0].ticket_key}`);
                            // this.router.navigateByUrl(`/stream/${this.getEventData.id}`);
                          }
                        }
                      }
                    }).catch(error => {
                      this.ngxLoader.stop();
                    });
                  }
                } else {
                  console.log('testreturnurl', this.returnUrl);
                  if (!this.returnUrl) {
                    if (!this.skipIcRedirection) {
                      const channelSegment = this.router.url.split('/')[1];
                      // Wait for the group-preference save (if any) to complete before opening the
                      // AI-agent panel and navigating, so its refetch (triggered below via
                      // setTriggerAiAgent) sees the just-saved preference instead of racing it.
                      groupSeed$.subscribe(() => {
                        this.commanSubscribeService.setTriggerAiAgent(true);
                        this.router.navigate([signupGroupSlug ? '/' + channelSegment + '/' + signupGroupSlug : '/' + channelSegment]);
                      });
                    } else {
                      this.router.navigate([this.skipIcRedirection]).then(() => {
                        setTimeout(() => {
                          window.location.reload();
                        }, 500);
                      });
                    }
                  } else {
                    if (this.router.url.includes('stream')) {
                      this.router.navigate([this.returnUrl]).then(() => {
                        setTimeout(() => {
                          window.location.reload();
                        }, 500);
                      });
                    } else if (this.returnUrl)
                      this.router.navigate([this.returnUrl]);
                    else
                      this.router.navigateByUrl('/' + this.router.url.split('/')[1]);
                  }
                }
              }
              // this.landingPageService.openConsumerSignIn();
            } else {
              this.toastr.error("User not verified.");
            }
          });
        } else if (response.data.status == 1 && response.data.message == "Wrong OTP") {
          this.ngxLoader.stop();
          this.toastr.error("Wrong Verification Code");
        } else {
          this.ngxLoader.stop();
          this.toastr.error(response.data.message);
        }
      }).catch(error => {
        this.ngxLoader.stop();
      });
    }
  }

  OL_updateProfile(user_id, callBack) {
    let reqData = {
      organization_id: this.organizationId,
      custom_attributes: {
        is_user_verify: 1
      }
    }
    this.appService.postRequest(API.GET_USER_INFO,reqData).subscribe(result => {
      callBack("success");
    }, error => {
      callBack("error");
    });
  }

  // OL_resendVerifyCode() {
  //   this.ngxLoader.start();
  //   let req = { factor_id: 60000, display_name: "Arevea Tv", expires_in: 900 };
  //   this.appService.OL_PostRequest(`api/2/mfa/users/${this.formdata.user_id}/registrations`, req).subscribe(result1 => {
  //     this.ngxLoader.stop();
  //     if (result1.id) {
  //       this.formdata.registration_id = result1.id;
  //       this.toastr.success("Verification code sent to the " + this.formdata.email);
  //     }
  //   }, error => {
  //     this.ngxLoader.stop();
  //   });
  // }

  OL_resendVerifyCode() {
    let myInit = {
      headers: {},
      response: true,
      body: {
        email: this.formdata.email ? this.formdata.email.toLowerCase() : "",
        type: "email_verification"
      }
    }
    this.ngxLoader.start();
    AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.SEND_OTP, myInit).then(response => {
      if (response.status == 200) {
        this.ngxLoader.stop();
        this.toastr.success("Verification code sent to the " + this.formdata.email);
      }
    }).catch(error => {
      this.ngxLoader.stop();
    });
  }

  OpenSign() {
    this.matDialogRef.close("");
    this.landingPageService.openConsumerSignIn();
  }
  ngOnDestroy() {
    this.performerInfoSubscription?.unsubscribe();
    // this.storageService.deleteItem('eventInfo');
  }


}
